import React from "react";

export default function Versao1021() {
  return (
    <div className="space-y-10 text-base text-[#333]">
      {/* Aumentei espaço geral e a fonte */}

      {/* MELHORIAS */}
      <section>
        <h3 className="text-xl font-semibold text-[#4d4d4d]">
          🔧 Melhorias Implementadas
        </h3>

        <ul className="list-disc ml-6 space-y-4 text-slate-700 text-base">
          <li>
            📌 <strong>Filtro no campo "Tipo de Serviço"</strong> do módulo de Agendamentos:  
            agora o usuário pode digitar e o sistema filtra automaticamente os tipos cadastrados.
          </li>

          <li>
            🔠 <strong>Tipos de serviço agora estão em ordem alfabética</strong>  
            tanto no módulo de <strong>Agendamentos</strong> quanto no módulo de <strong>Chamados</strong>.
          </li>

          <li>
            📑 <strong>Relatório de Chamados agora possui filtro por Status</strong>, permitindo selecionar apenas chamados abertos, encerrados ou todos.
          </li>
        </ul>
      </section>

      {/* AVISO TEMPORÁRIO */}
      <section className="p-6 rounded-md border border-red-300 bg-red-50 text-base">
        <h3 className="text-xl font-semibold text-red-600 mb-4">
          🚨 Ajustes Temporários
        </h3>

        <ul className="list-disc ml-6 space-y-4 text-red-700 text-base">
          <li>
            ⚠️ O menu e a tela de usuário foram temporariamente removidos devido a um erro identificado.
          </li>

          <li>
            📅 Eles serão adicionados novamente na versão <strong>1.0.22</strong> após a correção.
          </li>
        </ul>
      </section>

    </div>
  );
}
